import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import Logo from "@/components/Logo";
import { FIRM } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-card/40">
      <div className="mx-auto max-w-7xl px-4 pb-28 pt-16 sm:px-8 lg:px-16 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center">
              <Logo className="h-16 w-auto" />
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted-foreground">
              {FIRM.positioning} Boutique counsel for construction, business, and real estate matters across Middle Tennessee.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Navigate</p>
            <ul className="mt-5 space-y-3 text-sm">
              {[["/", "Home"], ["/about", "About"], ["/services", "Services"], ["/blog", "Blog"], ["/contact", "Contact"]].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="gold-underline pb-0.5 text-foreground/80 hover:text-foreground">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Contact</p>
            <ul className="mt-5 space-y-4 text-sm text-foreground/80">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
                <span>{FIRM.address}, {FIRM.city}<br /><span className="text-xs text-muted-foreground">{FIRM.hours}</span></span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
                <a href={FIRM.phoneHref} className="gold-underline">{FIRM.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
                <a href={`mailto:${FIRM.email}`} className="gold-underline">{FIRM.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-border pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-muted-foreground">
            Copyright © {new Date().getFullYear()} Harrison Litigation Team, PLLC — All Rights Reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            Attorney Advertising. No attorney-client relationship is formed by use of this site.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em]">
            <Link to="/privacy-policy" className="gold-underline pb-0.5 text-muted-foreground hover:text-gold">Privacy Policy</Link>
            <span className="mx-2 text-border">·</span>
            <Link to="/terms-of-service" className="gold-underline pb-0.5 text-muted-foreground hover:text-gold">Terms of Service</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
